<script>
import {axios} from "../../mixins";

export default {
  name: "sendRecruiterLink",

  mixins: [axios],

  props: {
    user_id: {
      type: Number,
      required: true,
      default: 0,
    },
    recruiter_link: {
      type: String,
      required: true,
      default: '',
    },
    email: {
      type: String,
      required: true,
      default: 'My Email',
    }
  },

  data() {
    return {
      buttonText: ''
    }
  },

  computed: {
    text() {
      return 'Send Recruitment Link To ' + this.email;
    }
  },

  created() {
      this.buttonText = this.text;
  },

  methods: {
    sendRecruiterLink(id) {
      this.buttonText = 'Sending...';
      this.get('account/' + id + '/send').then((response) => {
        if (response.data.success) {
          this.buttonText = 'Sent!';
        } else {
          this.buttonText = 'Something went wrong.';
        }
      }).catch((errors) => {
        this.buttonText = 'Something went wrong.';
      })
    }
  }
}
</script>

<template>
  <div class="p-2 my-2 bg-grey-dark rounded text-white">

    <div class="flex flex-row justify-between">
      <span class="px-2 py-1">
        Shareable Recruitment Link: {{ this.recruiter_link }}
      </span>
      <button type="button" name="recruiter-link" id="recruiter-id" @click="sendRecruiterLink(this.user_id)"
              class="px-2 py-1 rounded font-semibold inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker">
        {{ this.buttonText }}
      </button>
    </div>
  </div>
</template>

